module.exports = __webpack_public_path__ + "img/07.f655d96f.png";